(function () {
  const PROCESSED = 'data-a11y-landmark';
  const TARGETS = [
    { selector: '#truyo-consent-module', label: 'Cookie preferences' },
    { selector: '#cookieSettingButton', label: 'Cookie settings' },
  ];
  const LANDMARK_ROLES = [
    'banner',
    'complementary',
    'contentinfo',
    'form',
    'main',
    'navigation',
    'region',
    'search',
  ];
  const LANDMARK_TAGS = ['MAIN', 'HEADER', 'FOOTER', 'NAV', 'ASIDE'];
  const INTERACTIVE_TAGS = ['A', 'BUTTON', 'INPUT', 'SELECT', 'TEXTAREA'];

  function isLandmark(node) {
    const role = node.getAttribute('role');
    if (role && LANDMARK_ROLES.indexOf(role) !== -1) return true;
    return LANDMARK_TAGS.indexOf(node.tagName) !== -1;
  }

  function insideLandmark(el) {
    let node = el.parentElement;
    while (node && node !== document.body) {
      if (isLandmark(node)) return true;
      node = node.parentElement;
    }
    return false;
  }

  function hasAccessibleName(el) {
    return el.hasAttribute('aria-label') || el.hasAttribute('aria-labelledby');
  }

  function wrapInRegion(el, label) {
    const region = document.createElement('aside');
    region.setAttribute('role', 'region');
    region.setAttribute('aria-label', label);
    region.setAttribute(PROCESSED, 'wrapper');
    el.parentNode.insertBefore(region, el);
    region.appendChild(el);
  }

  function annotate(el, label) {
    if (el.hasAttribute(PROCESSED)) return;
    el.setAttribute(PROCESSED, 'done');

    if (insideLandmark(el)) return;

    if (INTERACTIVE_TAGS.indexOf(el.tagName) !== -1) {
      wrapInRegion(el, label);
      return;
    }

    if (!isLandmark(el)) {
      el.setAttribute('role', 'region');
    }
    if (!hasAccessibleName(el)) {
      el.setAttribute('aria-label', label);
    }
  }

  function scan() {
    for (let i = 0; i < TARGETS.length; i++) {
      const target = TARGETS[i];
      const nodes = document.querySelectorAll(target.selector);
      for (let j = 0; j < nodes.length; j++) {
        annotate(nodes[j], target.label);
      }
    }
  }

  scan();

  const observer = new MutationObserver(scan);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  }

  const delays = [500, 1500, 3000, 6000];
  for (let i = 0; i < delays.length; i++) {
    setTimeout(scan, delays[i]);
  }
})();
